import { render, staticRenderFns } from "./CraftInfo.vue?vue&type=template&id=116dc02d&scoped=true&"
import script from "./CraftInfo.vue?vue&type=script&lang=js&"
export * from "./CraftInfo.vue?vue&type=script&lang=js&"
import style0 from "./CraftInfo.vue?vue&type=style&index=0&id=116dc02d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116dc02d",
  null
  
)

export default component.exports